import ServiceGraphQL from 'src/service/gql-service';
import { getCompanyImageUploadUrl } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetCompanyImageUploadUrl = (variables) => {
  const params = {
    query: getCompanyImageUploadUrl.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
